// Edit this file to add, remove, or modify job postings

export const jobPostings = [
  {
    id: 1,
    title: "Field Service Technician",
    location: "California (Travel Required)",
    type: "Full-Time",
    experience: "2-5 years",
    description: "We are seeking an experienced Field Service Technician to perform on-site coating applications, equipment repairs, and customer support throughout California and surrounding states.",
    responsibilities: [
      "Apply protective coatings and perform epoxy repairs on industrial equipment",
      "Conduct surface preparation and quality control inspections",
      "Provide technical support to customers during planned shutdowns and emergency repairs",
      "Maintain detailed documentation and QA/QC records",
      "Travel to customer sites as needed (up to 75% travel)"
    ],
    qualifications: [
      "2+ years experience in industrial coatings or equipment repair",
      "Knowledge of surface preparation techniques",
      "Ability to work in industrial environments and confined spaces",
      "Valid driver's license and clean driving record",
      "TWIC card preferred or ability to obtain",
      "NACE/AMPP certification a plus"
    ]
  },
  {
    id: 2,
    title: "Project Manager",
    location: "California",
    type: "Full-Time",
    experience: "5+ years",
    description: "BCS is looking for an experienced Project Manager to oversee coating and repair projects from bid to completion. This role requires strong technical knowledge and excellent customer relationship skills.",
    responsibilities: [
      "Manage multiple coating and repair projects simultaneously",
      "Develop project schedules, budgets, and resource allocation plans",
      "Coordinate with customers, vendors, and field technicians",
      "Ensure projects meet quality standards and safety requirements",
      "Prepare proposals, quotes, and technical specifications"
    ],
    qualifications: [
      "5+ years in industrial coatings or maintenance project management",
      "Strong understanding of epoxy coating systems and application methods",
      "Excellent communication and organizational skills",
      "Proficiency in project management software",
      "Bachelor's degree in Engineering or related field preferred",
      "PMP certification a plus"
    ]
  },
  {
    id: 3,
    title: "HVAC Service Technician",
    location: "Southern California",
    type: "Full-Time",
    experience: "3-7 years",
    description: "Join our team as an HVAC Service Technician specializing in chiller, condenser, and cooling tower repairs. This position focuses on tubesheet repairs, coating applications, and preventive maintenance.",
    responsibilities: [
      "Perform maintenance and repairs on chillers, condensers, and cooling towers",
      "Execute tubesheet coating and repair procedures",
      "Conduct tube brushing and eddy current testing",
      "Replace cooling tower fill media and perform structural repairs",
      "Provide emergency response services"
    ],
    qualifications: [
      "3+ years HVAC service experience with focus on chillers/cooling towers",
      "Understanding of coating and epoxy repair techniques",
      "EPA Universal certification required",
      "Ability to read technical drawings and specifications",
      "Strong troubleshooting and problem-solving skills",
      "Willingness to work flexible hours including on-call rotation"
    ]
  }
];
